import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { ProductClaim } from '../types/product-claim.type';

export type GetListProductClaimParams = Partial<ApiParamsDefault>;
export type GetProductClaimResponse = ApiResponsePagination<ProductClaim>;

export const getListProductClaim = async (
  params?: GetListProductClaimParams
): Promise<GetProductClaimResponse> => {
  const url = 'product-promotion';

  return await apiClient.get(url, { params });
};

export const GET_LIST_KLAIM_PRODUK_QUERY_KEY = 'list-klaim-produk';
export function getListProductClaimQueryOptions(
  params?: GetListProductClaimParams
) {
  return queryOptions({
    queryKey: [GET_LIST_KLAIM_PRODUK_QUERY_KEY, params],
    queryFn: () => getListProductClaim(params),
  });
}
